// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"b7b26b7e","769":"059039bd"}[chunkId] + ".chunk.js";
};